if (!customElements.get('permania-member-popup')) {
  customElements.define('permania-member-popup', class PermaniaMemberPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.storageKey = 'permania-welcome-dismissed';
      this.querySelectorAll('[data-popup-close]').forEach((button) => {
        button.addEventListener('click', () => this.dialog.close());
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        try { localStorage.setItem(this.storageKey, String(Date.now())); } catch (_) { /* Storage can be unavailable. */ }
      });
      if (this.dataset.designMode === 'true') {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target.contains(this) || this.contains(event.target)) this.open();
        });
        return;
      }
      if (this.querySelector('.pm-welcome__success, .pm-welcome__error')) {
        this.open();
        return;
      }
      let dismissedAt = 0;
      try { dismissedAt = Number(localStorage.getItem(this.storageKey)) || 0; } catch (_) { /* Continue without storage. */ }
      const repeatMs = (Number(this.dataset.repeatDays) || 14) * 86400000;
      if (Date.now() - dismissedAt < repeatMs) return;
      this.timer = window.setTimeout(() => this.open(), Number(this.dataset.delay) || 5000);
    }

    disconnectedCallback() { window.clearTimeout(this.timer); }

    open() {
      if (!this.dialog?.open && typeof this.dialog?.showModal === 'function') this.dialog.showModal();
    }
  });
}

